/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {initiateCashInInstrumentSelection} from '../api'

export const useMutationInitiateCashInInstrumentSelection = createReactQueryMutationHook('initiateCashInInstrumentSelection', initiateCashInInstrumentSelection)
